import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, ɵɵelement, ɵɵpipe, ɵɵnextContext, ɵɵproperty, ɵɵpipeBind1, ɵɵsanitizeHtml, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵtemplate, ɵɵpureFunction1, ɵɵadvance, EventEmitter, ɵɵdirectiveInject, ɵɵdefineComponent, Component, Output, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { isNullOrUndefined } from 'util';
import { LocalService } from '@akeela/local-storage';
import { AkeelaWorkflowService, RouteUtilsService } from '@akeela/workflow';
import { HttpService } from '@akeela/properties';
import { NgIf, NgForOf, NgClass, CommonModule } from '@angular/common';
import { I18nPipe, I18nModule } from '@akeela/i18n';

class AkeelaBreadcrumbService {
    constructor(http) {
        this.http = http;
        this.breadcrumbOptions$ = new BehaviorSubject(null);
        this.breadcrumbKey$ = new BehaviorSubject(null);
    }
    setbreadcrumbOptions(breadcrumbOptions) {
        this.breadcrumbOptions$.next(breadcrumbOptions);
    }
    get breadcrumbOptions() {
        return this.breadcrumbOptions$;
    }
    setbreadcrumbKey(breadcrumbKey) {
        this.breadcrumbKey$.next(breadcrumbKey);
    }
}
/** @nocollapse */ AkeelaBreadcrumbService.ɵfac = function AkeelaBreadcrumbService_Factory(t) { return new (t || AkeelaBreadcrumbService)(ɵɵinject(HttpClient)); };
/** @nocollapse */ AkeelaBreadcrumbService.ɵprov = ɵɵdefineInjectable({ token: AkeelaBreadcrumbService, factory: AkeelaBreadcrumbService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaBreadcrumbService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

function BreadcrumbComponent_div_0_li_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 9);
    ɵɵtext(1, " / ");
    ɵɵelementEnd();
} }
function BreadcrumbComponent_div_0_li_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 10);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const breadcrumbOption_r3 = ɵɵnextContext().$implicit;
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, breadcrumbOption_r3 == null ? null : breadcrumbOption_r3.name), ɵɵsanitizeHtml);
} }
function BreadcrumbComponent_div_0_li_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const breadcrumbOption_r3 = ɵɵnextContext().$implicit;
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, breadcrumbOption_r3 == null ? null : breadcrumbOption_r3.name), ɵɵsanitizeHtml);
} }
const _c0 = function (a0) { return { "pl-2": a0 }; };
function BreadcrumbComponent_div_0_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "li", 4);
    ɵɵelementStart(1, "a", 5);
    ɵɵlistener("click", function BreadcrumbComponent_div_0_li_2_Template_a_click_1_listener() { ɵɵrestoreView(_r11); const breadcrumbOption_r3 = ctx.$implicit; const i_r4 = ctx.index; const ctx_r10 = ɵɵnextContext(2); return ctx_r10.rediect(breadcrumbOption_r3, i_r4); });
    ɵɵtemplate(2, BreadcrumbComponent_div_0_li_2_span_2_Template, 2, 0, "span", 6);
    ɵɵtemplate(3, BreadcrumbComponent_div_0_li_2_span_3_Template, 2, 3, "span", 7);
    ɵɵtemplate(4, BreadcrumbComponent_div_0_li_2_span_4_Template, 2, 3, "span", 8);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(4, _c0, i_r4 > 0));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", i_r4 > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", i_r4 + 1 < ctx_r2.breadcrumbOptions.length);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", i_r4 + 1 == ctx_r2.breadcrumbOptions.length);
} }
function BreadcrumbComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵelementStart(1, "ul");
    ɵɵtemplate(2, BreadcrumbComponent_div_0_li_2_Template, 5, 6, "li", 3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r0.breadcrumbOptions);
} }
function BreadcrumbComponent_div_1_div_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 15);
    ɵɵlistener("click", function BreadcrumbComponent_div_1_div_1_a_1_Template_a_click_0_listener() { ɵɵrestoreView(_r18); const ctx_r17 = ɵɵnextContext(); const breadcrumbOption_r13 = ctx_r17.$implicit; const i_r14 = ctx_r17.index; const ctx_r16 = ɵɵnextContext(2); return ctx_r16.rediect(breadcrumbOption_r13, i_r14); });
    ɵɵelement(1, "i", 16);
    ɵɵelementEnd();
} }
function BreadcrumbComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, BreadcrumbComponent_div_1_div_1_a_1_Template, 2, 0, "a", 14);
    ɵɵelementEnd();
} if (rf & 2) {
    const i_r14 = ctx.index;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", i_r14 == 0);
} }
function BreadcrumbComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵtemplate(1, BreadcrumbComponent_div_1_div_1_Template, 2, 1, "div", 13);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.breadcrumbOptions);
} }
class BreadcrumbComponent {
    constructor(route, router, _sanitizer, _httpService, _breadcrumbService, akeelaWorkflowService, routeService, localStorage) {
        this.route = route;
        this.router = router;
        this._sanitizer = _sanitizer;
        this._httpService = _httpService;
        this._breadcrumbService = _breadcrumbService;
        this.akeelaWorkflowService = akeelaWorkflowService;
        this.routeService = routeService;
        this.localStorage = localStorage;
        this.response = new EventEmitter();
        this.breadcrumbOptions = [];
    }
    ngOnInit() {
        this.role = this.localStorage.getItem('role');
        this.profile = this.localStorage.getItem('profile');
        this.audience = this.localStorage.getItem('audience');
        this.transactionNumber = this.akeelaWorkflowService.transactionNumber.getValue();
        this.akeelaWorkflowService.transactionData$.subscribe((transactionData) => {
            if (!isNullOrUndefined(transactionData)) {
                this.transactionData = transactionData;
            }
        });
        this._breadcrumbService.breadcrumbOptions$.subscribe(breadcrumbOptions => {
            if (!isNullOrUndefined(breadcrumbOptions)) {
                this.breadcrumbOptions = breadcrumbOptions;
            }
            else {
                this.breadcrumbOptions = [];
            }
        });
        this._breadcrumbService.breadcrumbKey$.subscribe(breadcrumbKey => {
            this.processData(breadcrumbKey);
        });
    }
    endLink(data) {
        const temp2 = {
            'key': data,
            'name': data,
            'endLink': true
        };
        return temp2;
    }
    rediect(bo, i) {
        if (i === 0) {
            const queryParams = bo.request;
            this.response.emit({
                action: 'navigate',
                url: bo.url
            });
            this.router.navigate([bo.url], { queryParams });
        }
    }
    processData(breadcrumbArray) {
        this._breadcrumbService.setbreadcrumbOptions(null);
        if (!isNullOrUndefined(breadcrumbArray)) {
            if (breadcrumbArray.length > 0) {
                const breadcrumbKey = breadcrumbArray.filter((item) => item.profile === this.profile);
                this.processDataBreadcrumb(breadcrumbKey[0]);
            }
        }
    }
    processDataBreadcrumb(breadcrumbKey) {
        if (!isNullOrUndefined(breadcrumbKey)) {
            const temp = [];
            if (breadcrumbKey.key) {
                this._httpService.executeFrontRequest(this, breadcrumbKey.key, true).subscribe((response) => {
                    if (!isNullOrUndefined(response)) {
                        if (!isNullOrUndefined(response.response.urlTemplate) && response.response.urlTemplate !== 'null' && response.response.urlTemplate !== false) {
                            const jsData = JSON.parse(response.response.urlTemplate);
                            for (const element of Object.keys(jsData)) {
                                this._httpService.executeFrontRequest(this, jsData[element]).subscribe((response2) => {
                                    if (!isNullOrUndefined(response2)) {
                                        const temp2 = {
                                            'key': response2.response.alternateName,
                                            'name': response2.response.name,
                                            'url': response2.url,
                                            'request': response2.request,
                                            'endLink': false
                                        };
                                        temp.push(temp2);
                                    }
                                });
                            }
                            if (breadcrumbKey.endLink) {
                                temp.push(this.endLink(breadcrumbKey.endLink));
                            }
                            this._breadcrumbService.setbreadcrumbOptions(temp);
                        }
                        else {
                            if (breadcrumbKey.endLink) {
                                temp.push(this.endLink(breadcrumbKey.endLink));
                            }
                            this._breadcrumbService.setbreadcrumbOptions(temp);
                        }
                    }
                });
            }
            if (!breadcrumbKey.key && breadcrumbKey.endLink) {
                temp.push(this.endLink(breadcrumbKey.endLink));
                this._breadcrumbService.setbreadcrumbOptions(temp);
            }
        }
    }
}
/** @nocollapse */ BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(AkeelaBreadcrumbService), ɵɵdirectiveInject(AkeelaWorkflowService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ BreadcrumbComponent.ɵcmp = ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["akeela-breadcrumb"]], outputs: { response: "response" }, decls: 2, vars: 2, consts: [["class", "breadcrumb d-none d-md-block", 4, "ngIf"], ["class", "breadcrumb d-block d-md-none fz-16", 4, "ngIf"], [1, "breadcrumb", "d-none", "d-md-block"], [3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], ["routerLink", "[]", 1, "p-0", 3, "click"], ["class", "barra", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], ["class", " final", 3, "innerHTML", 4, "ngIf"], [1, "barra"], [3, "innerHTML"], [1, "final", 3, "innerHTML"], [1, "breadcrumb", "d-block", "d-md-none", "fz-16"], [4, "ngFor", "ngForOf"], ["routerLink", "[]", "class", " text-secondary", 3, "click", 4, "ngIf"], ["routerLink", "[]", 1, "text-secondary", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-arrow-left"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, BreadcrumbComponent_div_0_Template, 3, 1, "div", 0);
        ɵɵtemplate(1, BreadcrumbComponent_div_1_Template, 2, 1, "div", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.breadcrumbOptions.length);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.breadcrumbOptions.length > 2);
    } }, directives: [NgIf, NgForOf, NgClass], pipes: [I18nPipe], styles: ["[_nghost-%COMP%]{--ak-breadcrumb-bg:#fff;--ak-breadcrumb-color:#a6c6f3;--ak-breadcrumb-color-final:#6c757d;--ak-breadcrumb-color-hover:#466bb5}.breadcrumb[_ngcontent-%COMP%]{background:var(--ak-breadcrumb-bg);border-radius:.25rem;display:flex;flex-wrap:wrap;font-size:1rem;list-style:none;margin-bottom:.75rem;padding:.75rem 0 0}ul[_ngcontent-%COMP%]{list-style-type:none;margin:0;overflow:hidden;padding:0}li[_ngcontent-%COMP%]{float:left}li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--ak-breadcrumb-color);cursor:pointer;display:block;text-align:center;text-decoration:none}li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:var(--ak-breadcrumb-color-hover);text-decoration:underline}.barra[_ngcontent-%COMP%], li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   .final[_ngcontent-%COMP%], li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover   .final[_ngcontent-%COMP%]{color:var(--ak-breadcrumb-color-final);cursor:default;text-decoration:none!important}.fz-16[_ngcontent-%COMP%]{font-size:16px!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-breadcrumb',
                templateUrl: './breadcrumb.component.html',
                styleUrls: ['./breadcrumb.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: DomSanitizer }, { type: HttpService }, { type: AkeelaBreadcrumbService }, { type: AkeelaWorkflowService }, { type: RouteUtilsService }, { type: LocalService }]; }, { response: [{
            type: Output
        }] }); })();

class AkeelaBreadcrumbModule {
}
/** @nocollapse */ AkeelaBreadcrumbModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaBreadcrumbModule });
/** @nocollapse */ AkeelaBreadcrumbModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaBreadcrumbModule_Factory(t) { return new (t || AkeelaBreadcrumbModule)(); }, providers: [AkeelaBreadcrumbService], imports: [[
            CommonModule,
            I18nModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkeelaBreadcrumbModule, { declarations: [BreadcrumbComponent], imports: [CommonModule,
        I18nModule], exports: [BreadcrumbComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaBreadcrumbModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    I18nModule
                ],
                declarations: [BreadcrumbComponent],
                providers: [AkeelaBreadcrumbService],
                exports: [BreadcrumbComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of akeela-breadcrumb
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaBreadcrumbModule, AkeelaBreadcrumbService, BreadcrumbComponent };
//# sourceMappingURL=akeela-breadcrumb.js.map
